import { mountStandaloneApp } from '@yuksalish/ui'
import { financeMessages } from './i18n'
import './styles.css'
import OverviewPage from './pages/OverviewPage.vue'
import AccountsPage from './pages/AccountsPage.vue'
import AccountDetailPage from './pages/AccountDetailPage.vue'
import AccountFormPage from './pages/AccountFormPage.vue'
import TransfersPage from './pages/TransfersPage.vue'
import TransferFormPage from './pages/TransferFormPage.vue'
import CashFlowPage from './pages/CashFlowPage.vue'
import CurrencyExposurePage from './pages/CurrencyExposurePage.vue'
import ReconciliationPage from './pages/ReconciliationPage.vue'
import ReceivablesInvoicesPage from './pages/ReceivablesInvoicesPage.vue'
import ReceivableInvoiceDetailPage from './pages/ReceivableInvoiceDetailPage.vue'
import RevenueVsCollectionsPage from './pages/RevenueVsCollectionsPage.vue'
import PaymentsPage from './pages/PaymentsPage.vue'
import PaymentFormPage from './pages/PaymentFormPage.vue'
import AdjustmentsPage from './pages/AdjustmentsPage.vue'
import AdjustmentFormPage from './pages/AdjustmentFormPage.vue'
import SupplierInvoicesPage from './pages/SupplierInvoicesPage.vue'
import SupplierInvoiceFormPage from './pages/SupplierInvoiceFormPage.vue'
import SupplierInvoiceDetailPage from './pages/SupplierInvoiceDetailPage.vue'
import PayablesAgingPage from './pages/PayablesAgingPage.vue'
import CostingPage from './pages/CostingPage.vue'
import ProductCostWorkspacePage from './pages/ProductCostWorkspacePage.vue'
import PayrollPage from './pages/PayrollPage.vue'
import PayrollPeriodsPage from './pages/PayrollPeriodsPage.vue'
import PayrollAccrualsPage from './pages/PayrollAccrualsPage.vue'
import PayrollAdjustmentsPage from './pages/PayrollAdjustmentsPage.vue'
import PayrollRunsPage from './pages/PayrollRunsPage.vue'
import PayrollRunDetailPage from './pages/PayrollRunDetailPage.vue'
import PayrollPostingsPage from './pages/PayrollPostingsPage.vue'
import PayrollReportsPage from './pages/PayrollReportsPage.vue'
import PayrollStatementPage from './pages/PayrollStatementPage.vue'

const reportsView = 'finance_reports.view'
const invoicesView = 'invoices.view'
const paymentsView = 'payments.view'
const paymentsCreate = 'payments.create'
const paymentsUpdate = 'payments.update'
const adjustmentsView = 'finance_adjustments.view'
const adjustmentsManage = 'finance_adjustments.manage'
const supplierInvoicesView = 'supplier_invoices.view'
const supplierInvoicesCreate = 'supplier_invoices.create'
const supplierInvoicesUpdate = 'supplier_invoices.update'
const productsView = 'products.view'
const timesheetsView = 'timesheets.view'
const accountsView = 'financial_accounts.view'
const accountsManage = 'financial_accounts.manage'
const treasuryView = 'treasury_transactions.view'
const treasuryManage = 'treasury_transactions.manage'
const payrollPeriodsView = 'payroll_periods.view'
const payrollPeriodsManage = 'payroll_periods.manage'
const payrollAccrualsView = 'payroll_accruals.view'
const payrollAccrualsApprove = 'payroll_accruals.approve'
const payrollAccrualsReverse = 'payroll_accruals.reverse'
const payrollAdjustmentsView = 'payroll_adjustments.view'
const payrollAdjustmentsManage = 'payroll_adjustments.manage'
const payrollAdjustmentsApprove = 'payroll_adjustments.approve'
const payrollRunsView = 'payroll_runs.view'
const payrollRunsManage = 'payroll_runs.manage'
const payrollRunsApprove = 'payroll_runs.approve'
const payrollPostingsView = 'payroll_postings.view'
const payrollPostingsManage = 'payroll_postings.manage'
const payrollReportsView = 'payroll_reports.view'

mountStandaloneApp({
  code: 'finance',
  title: {
    en: financeMessages.en.finance.appTitle,
    ru: financeMessages.ru.finance.appTitle,
    uz: financeMessages.uz.finance.appTitle,
  },
  description: {
    en: financeMessages.en.finance.appDescription,
    ru: financeMessages.ru.finance.appDescription,
    uz: financeMessages.uz.finance.appDescription,
  },
  accent: '#4e6651',
  messages: financeMessages,
  requiredPermissions: [reportsView],
  navigation: [

    {
      label: {
        en: financeMessages.en.finance.nav.overview,
        ru: financeMessages.ru.finance.nav.overview,
        uz: financeMessages.uz.finance.nav.overview,
      },
      to: '/overview',
      permission: reportsView,
    },
    {
      label: {
        en: financeMessages.en.finance.nav.receivables,
        ru: financeMessages.ru.finance.nav.receivables,
        uz: financeMessages.uz.finance.nav.receivables,
      },
      to: '/receivables/invoices',
      permission: invoicesView,
      children: [
        {
          label: {
            en: financeMessages.en.finance.nav.invoices,
            ru: financeMessages.ru.finance.nav.invoices,
            uz: financeMessages.uz.finance.nav.invoices,
          },
          to: '/receivables/invoices',
          permission: invoicesView,
        },
        {
          label: {
            en: financeMessages.en.finance.nav.revenueVsCollections,
            ru: financeMessages.ru.finance.nav.revenueVsCollections,
            uz: financeMessages.uz.finance.nav.revenueVsCollections,
          },
          to: '/receivables/revenue-vs-collections',
          permission: reportsView,
        },
        {
          label: {
            en: financeMessages.en.finance.nav.collections,
            ru: financeMessages.ru.finance.nav.collections,
            uz: financeMessages.uz.finance.nav.collections,
          },
          to: '/receivables/collections',
          permission: paymentsView,
        },
        {
          label: {
            en: financeMessages.en.finance.nav.adjustments,
            ru: financeMessages.ru.finance.nav.adjustments,
            uz: financeMessages.uz.finance.nav.adjustments,
          },
          to: '/receivables/adjustments',
          permission: adjustmentsView,
        },
      ],
    },
    {
      label: {
        en: financeMessages.en.finance.nav.payables,
        ru: financeMessages.ru.finance.nav.payables,
        uz: financeMessages.uz.finance.nav.payables,
      },
      to: '/payables/invoices',
      permission: supplierInvoicesView,
      children: [
        {
          label: {
            en: financeMessages.en.finance.nav.supplierInvoices,
            ru: financeMessages.ru.finance.nav.supplierInvoices,
            uz: financeMessages.uz.finance.nav.supplierInvoices,
          },
          to: '/payables/invoices',
          permission: supplierInvoicesView,
        },
        {
          label: {
            en: financeMessages.en.finance.nav.supplierPayments,
            ru: financeMessages.ru.finance.nav.supplierPayments,
            uz: financeMessages.uz.finance.nav.supplierPayments,
          },
          to: '/payables/payments',
          permission: paymentsView,
        },
        {
          label: {
            en: financeMessages.en.finance.nav.payablesAging,
            ru: financeMessages.ru.finance.nav.payablesAging,
            uz: financeMessages.uz.finance.nav.payablesAging,
          },
          to: '/payables/aging',
          permission: reportsView,
        },
      ],
    },
    {
      label: {
        en: financeMessages.en.finance.nav.productCostWorkspace,
        ru: financeMessages.ru.finance.nav.productCostWorkspace,
        uz: financeMessages.uz.finance.nav.productCostWorkspace,
      },
      to: '/product-costs',
      permission: 'product_costs.view',
    },
    {
      label: {
        en: financeMessages.en.finance.nav.costing,
        ru: financeMessages.ru.finance.nav.costing,
        uz: financeMessages.uz.finance.nav.costing,
      },
      to: '/costing',
      permission: productsView,
    },
    {
      label: {
        en: financeMessages.en.finance.nav.payroll,
        ru: financeMessages.ru.finance.nav.payroll,
        uz: financeMessages.uz.finance.nav.payroll,
      },
      to: '/payroll',
      permission: payrollPeriodsView,
      children: [
        {
          label: {
            en: financeMessages.en.finance.nav.payrollPeriods,
            ru: financeMessages.ru.finance.nav.payrollPeriods,
            uz: financeMessages.uz.finance.nav.payrollPeriods,
          },
          to: '/payroll',
          permission: payrollPeriodsView,
        },
        {
          label: {
            en: financeMessages.en.finance.nav.payrollAccruals,
            ru: financeMessages.ru.finance.nav.payrollAccruals,
            uz: financeMessages.uz.finance.nav.payrollAccruals,
          },
          to: '/payroll/accruals',
          permission: payrollAccrualsView,
        },
        {
          label: {
            en: financeMessages.en.finance.nav.payrollAdjustments,
            ru: financeMessages.ru.finance.nav.payrollAdjustments,
            uz: financeMessages.uz.finance.nav.payrollAdjustments,
          },
          to: '/payroll/adjustments',
          permission: payrollAdjustmentsView,
        },
        {
          label: {
            en: financeMessages.en.finance.nav.payrollRuns,
            ru: financeMessages.ru.finance.nav.payrollRuns,
            uz: financeMessages.uz.finance.nav.payrollRuns,
          },
          to: '/payroll/runs',
          permission: payrollRunsView,
        },
        {
          label: {
            en: financeMessages.en.finance.nav.payrollPostings,
            ru: financeMessages.ru.finance.nav.payrollPostings,
            uz: financeMessages.uz.finance.nav.payrollPostings,
          },
          to: '/payroll/postings',
          permission: payrollPostingsView,
        },
        {
          label: {
            en: financeMessages.en.finance.nav.payrollReports,
            ru: financeMessages.ru.finance.nav.payrollReports,
            uz: financeMessages.uz.finance.nav.payrollReports,
          },
          to: '/payroll/reports',
          permission: payrollReportsView,
        },
        {
          label: {
            en: financeMessages.en.finance.nav.payrollStatement,
            ru: financeMessages.ru.finance.nav.payrollStatement,
            uz: financeMessages.uz.finance.nav.payrollStatement,
          },
          to: '/payroll/statement',
          permission: payrollReportsView,
        },
        {
          label: {
            en: financeMessages.en.finance.nav.labourCost,
            ru: financeMessages.ru.finance.nav.labourCost,
            uz: financeMessages.uz.finance.nav.labourCost,
          },
          to: '/payroll/labour-cost',
          permission: timesheetsView,
        },
      ],
    },
    {
      label: {
        en: financeMessages.en.finance.nav.treasury,
        ru: financeMessages.ru.finance.nav.treasury,
        uz: financeMessages.uz.finance.nav.treasury,
      },
      to: '/treasury/accounts',
      permission: accountsView,
      children: [
        {
          label: {
            en: financeMessages.en.finance.nav.accounts,
            ru: financeMessages.ru.finance.nav.accounts,
            uz: financeMessages.uz.finance.nav.accounts,
          },
          to: '/treasury/accounts',
          permission: accountsView,
        },
        {
          label: {
            en: financeMessages.en.finance.nav.transfers,
            ru: financeMessages.ru.finance.nav.transfers,
            uz: financeMessages.uz.finance.nav.transfers,
          },
          to: '/treasury/transfers',
          permission: treasuryView,
        },
        {
          label: {
            en: financeMessages.en.finance.nav.cashFlow,
            ru: financeMessages.ru.finance.nav.cashFlow,
            uz: financeMessages.uz.finance.nav.cashFlow,
          },
          to: '/treasury/cash-flow',
          permission: reportsView,
        },
        {
          label: {
            en: financeMessages.en.finance.nav.currencyExposure,
            ru: financeMessages.ru.finance.nav.currencyExposure,
            uz: financeMessages.uz.finance.nav.currencyExposure,
          },
          to: '/treasury/currency-exposure',
          permission: reportsView,
        },
        {
          label: {
            en: financeMessages.en.finance.nav.reconciliation,
            ru: financeMessages.ru.finance.nav.reconciliation,
            uz: financeMessages.uz.finance.nav.reconciliation,
          },
          to: '/treasury/reconciliation',
          permission: reportsView,
        },
      ],
    },
  ],
  routes: [
    { path: '', redirect: '/overview' },
    { path: 'overview', component: OverviewPage, meta: { permission: reportsView } },
    {
      path: 'receivables/invoices',
      component: ReceivablesInvoicesPage,
      meta: { permission: invoicesView },
    },
    {
      path: 'receivables/invoices/:id',
      component: ReceivableInvoiceDetailPage,
      meta: { permission: invoicesView },
    },
    {
      path: 'receivables/revenue-vs-collections',
      component: RevenueVsCollectionsPage,
      meta: { permission: reportsView },
    },
    {
      path: 'receivables/collections',
      component: PaymentsPage,
      meta: { permission: paymentsView, direction: 'inflow' },
    },
    {
      path: 'receivables/collections/new',
      component: PaymentFormPage,
      meta: { permission: paymentsCreate, direction: 'inflow' },
    },
    {
      path: 'receivables/collections/:id/edit',
      component: PaymentFormPage,
      meta: { permission: paymentsUpdate, direction: 'inflow' },
    },
    {
      path: 'receivables/adjustments',
      component: AdjustmentsPage,
      meta: { permission: adjustmentsView },
    },
    {
      path: 'receivables/adjustments/new',
      component: AdjustmentFormPage,
      meta: { permission: adjustmentsManage },
    },
    {
      path: 'payables/invoices',
      component: SupplierInvoicesPage,
      meta: { permission: supplierInvoicesView },
    },
    {
      path: 'payables/invoices/new',
      component: SupplierInvoiceFormPage,
      meta: { permission: supplierInvoicesCreate },
    },
    {
      path: 'payables/invoices/:id',
      component: SupplierInvoiceDetailPage,
      meta: { permission: supplierInvoicesView },
    },
    {
      path: 'payables/invoices/:id/edit',
      component: SupplierInvoiceFormPage,
      meta: { permission: supplierInvoicesUpdate },
    },
    {
      path: 'payables/payments',
      component: PaymentsPage,
      meta: { permission: paymentsView, direction: 'outflow' },
    },
    {
      path: 'payables/payments/new',
      component: PaymentFormPage,
      meta: { permission: paymentsCreate, direction: 'outflow' },
    },
    {
      path: 'payables/payments/:id/edit',
      component: PaymentFormPage,
      meta: { permission: paymentsUpdate, direction: 'outflow' },
    },
    {
      path: 'payables/aging',
      component: PayablesAgingPage,
      meta: { permission: reportsView },
    },
    { path: 'costing', component: CostingPage, meta: { permission: productsView } },
    { path: 'product-costs', component: ProductCostWorkspacePage, meta: { permission: 'product_costs.view' } },
    { path: 'payroll', component: PayrollPeriodsPage, meta: { permission: payrollPeriodsView } },
    {
      path: 'payroll/accruals',
      component: PayrollAccrualsPage,
      meta: { permission: payrollAccrualsView },
    },
    {
      path: 'payroll/adjustments',
      component: PayrollAdjustmentsPage,
      meta: { permission: payrollAdjustmentsView },
    },
    { path: 'payroll/runs', component: PayrollRunsPage, meta: { permission: payrollRunsView } },
    {
      path: 'payroll/runs/:id',
      component: PayrollRunDetailPage,
      meta: { permission: payrollRunsView },
    },
    {
      path: 'payroll/postings',
      component: PayrollPostingsPage,
      meta: { permission: payrollPostingsView },
    },
    {
      path: 'payroll/reports',
      component: PayrollReportsPage,
      meta: { permission: payrollReportsView },
    },
    {
      path: 'payroll/statement',
      component: PayrollStatementPage,
      meta: { permission: payrollReportsView },
    },
    {
      path: 'payroll/labour-cost',
      component: PayrollPage,
      meta: { permission: timesheetsView },
    },
    { path: 'treasury/accounts', component: AccountsPage, meta: { permission: accountsView } },
    { path: 'treasury/accounts/new', component: AccountFormPage, meta: { permission: accountsManage } },
    { path: 'treasury/accounts/:id', component: AccountDetailPage, meta: { permission: treasuryView } },
    {
      path: 'treasury/accounts/:id/edit',
      component: AccountFormPage,
      meta: { permission: accountsManage },
    },
    { path: 'treasury/transfers', component: TransfersPage, meta: { permission: treasuryView } },
    {
      path: 'treasury/transfers/new',
      component: TransferFormPage,
      meta: { permission: treasuryManage },
    },
    { path: 'treasury/cash-flow', component: CashFlowPage, meta: { permission: reportsView } },
    {
      path: 'treasury/currency-exposure',
      component: CurrencyExposurePage,
      meta: { permission: reportsView },
    },
    {
      path: 'treasury/reconciliation',
      component: ReconciliationPage,
      meta: { permission: reportsView },
    },
  ],
})
